window.onload = function () {
  var imgUrl =
    "https://cdn.shopify.com/s/files/1/0964/8373/7970/files/logo_a4520ad4-e023-498b-8397-5c19a4bf9f3d.svg?v=1776944750";

  // Create image
  var imgElement = $("<img>")
    .attr("src", imgUrl)
    .attr("alt", "Cookies Banner Image");

  // Get heading (Cookie Consent)
  var heading = $(".shopify-pc__banner__body h2");

  // Create wrapper div
  var wrapperDiv = $("<div>").addClass("custom-cookie-header");

  // Append image + heading inside wrapper
  wrapperDiv.append(imgElement);
  wrapperDiv.append(heading);

  // Prepend wrapper to banner body
  $(".shopify-pc__banner__body").prepend(wrapperDiv);

  // Show banner
  $(".shopify-pc__banner__dialog").css("display", "block");
};